import { objectToQueryParams, postForm } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  file: File;
  filepath?: string;
}

export function useUploadDocumentation() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ formData, filepath }: { formData: FormData; filepath?: string }) =>
      postForm<{ projectId: number }>({
        url: `/documentation/upload${objectToQueryParams({ filepath })}`,
        body: formData,
      }),
    onSuccess: (_, { filepath }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.getDocumentationDocs(filepath) });
    },
  });

  const uploadDocumentation = useCallback(
    (params: Params) => {
      const formData = new FormData();
      formData.append('file', params.file);
      mutate({ formData, filepath: params.filepath });
    },
    [mutate]
  );

  return {
    uploadDocumentation,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
